import { useCallback } from 'react';
import { AnalyticsPayload } from '../types/AdobeAnalyticsTypes';

export const useEventTracker = <T>(
  eventName: string,
  buildPayload: (payloadData: T) => AnalyticsPayload | AnalyticsPayload[],
) => {
  const trackEvent = useCallback(
    (payloadData: T) => {
      const builtPayload = buildPayload(payloadData);

      if (Array.isArray(builtPayload)) {
        builtPayload.forEach(payloadItem => {
          window.oneDataLayer.push(payloadItem);
        });
      } else {
        const finalPayload: AnalyticsPayload = {
          event: eventName,
          ...builtPayload,
        };
        window.oneDataLayer.push(finalPayload);
      }
    },
    [eventName, buildPayload],
  );

  return trackEvent;
};
